import ModalSlot, { slot } from "src/109323/components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3056744-652d7904deedd.png"
const slots = [
    {
        label: "Five Steps to Getting Started on ISF Live",
        href: "https://www.isflive.org/s/get-started"
    },
    {
        label: "Harness the Power of ISF Research and Tools with Expert Guidance",
        href: "https://www.isflive.org/s/services-overview"
    },
    {
        label: "Crowdsource Solutions to Regional Cyber Challenges in a Confidential Environment",
        href: "https://www.isflive.org/s/chapters?tabset-a732c=2"
    },
    {
        label: "Enhance Your Cyber Security Knowledge and Skills Irrespective of Your Location",
        href: "https://www.isflive.org/s/events-calendar-page"
    },
    {
        label: "Meet the Experts Behind the ISF",
        href: "https://www.isflive.org/s/about-us/meet-the-experts"
    },
    {
        label: "Get In Touch With Your Account Management Team",
        href: "https://www.isflive.org/s/contactused"
    },
    {
        label: "ISF Governance",
        href: "https://www.isflive.org/s/isf-governance"
    },
    {
        label: "ISF Member Code of Conduct",
        href: "https://www.isflive.org/s/contentdocument/0696M00000IVlG3QAL"
    },
    {
        label: "ISF Constitution",
        href: "https://www.isflive.org/s/contentdocument/0690J000005gbaSQAQ"
    },
    {
        href: "https://www.isflive.org/s/",
        label: "for more, please visit the ISF Library"
    }
]

const links = [
    ...slot(9, {
        height: 6.2,
        init: 11.9,
        space: (20.3-11.9)
    }),
    {
        width: "29%",
        height: "5.8%",
        top: "87.7%",
        left: "33.8%"
    }
]

export default () => <ModalSlot img={image} links={links} slots={slots} />